import { Box, useTheme } from '@mui/material';
import { isMobile } from 'react-device-detect';
import { Outlet } from 'react-router-dom';
import DefaultLayout from '../DefaultLayout';
import { SideBar } from './components';
import MobileSideBarAccount from './components/SideBar/MobileSidebar/MobileSidebarAccount';

const AccountLayout = () => {
  const theme = useTheme();

  return (
    <DefaultLayout hideFooter>
      <Box
        sx={{
          display: 'flex',
          height: '100%',
          flexDirection: isMobile ? 'column' : 'row',
        }}
      >
        {isMobile ? <MobileSideBarAccount /> : <SideBar />}
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            flexGrow: isMobile ? undefined : 1,
            padding: isMobile ? undefined : theme.spacing(3),
            position: 'relative',
            overflowY: 'auto',
          }}
        >
          <Outlet />
        </Box>
      </Box>
    </DefaultLayout>
  );
};

export default AccountLayout;
